import React from 'react';
import CsvBulkUpload from './CsvBulkUpload';

const PostBrokers = () => <CsvBulkUpload role="broker" title="Post Brokers" />;

export default PostBrokers;